import {store} from '../store';
import * as ModalSlices from '../reducers/modals';

const replacedKey = (key: string) => {
    return key.replace('modals/', '');
};

export const showModal = (name: string) => {
    for (const slice of Object.values(ModalSlices) as any[]) {
        if (slice.name && slice.actions) {
            const modalName = replacedKey(slice.name);
            if (name === modalName) {
                store.dispatch(slice.actions.makeTrue());
            } else {
                store.dispatch(slice.actions.makeFalse());
            }
        }
    }
};

export const hideModal = (name: string) => {
    for (const slice of Object.values(ModalSlices) as any[]) {
        if (slice.name && slice.actions) {
            const modalName = replacedKey(slice.name);
            if (name === modalName) store.dispatch(slice.actions.makeFalse());
        }
    }
};
